import { render, staticRenderFns } from "./ServiciosListaItem.vue?vue&type=template&id=1f955d2f&"
import script from "./ServiciosListaItem.vue?vue&type=script&lang=js&"
export * from "./ServiciosListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports